<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF BASIC
                    SCIENCES &
                    BIO-TECHNOLOGY</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Maths</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Post Graduate</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">Master of Science(Math)</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <h5 class="text-decoration-underline text-center">Math</h5>

        <div class="row">
            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Master of Science (Math)</b>
                    – The ARNI School of Basic Sciences & Bio-Technology offers a two-year postgraduate M.Sc. in Math
                    program that equips students with advanced core mathematical courses such as calculus, geometry,
                    algebra, statistics, and more. The pupils receive instruction in critical thinking and
                    problem-solving techniques. The MSc Maths Syllabus includes both lecture-based and independent
                    research units.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b></p>
                <ul>
                    <li> Mathematicians and the History of Maths</li>
                    <li> Algebra – I</li>
                    <li> Ordinary Differential Equations</li>
                    <li> Theorems and its Related Problems, Finite and Infinite Sets</li>
                    <li> Linear Differential Equations of nth Order</li>
                    <li> Discrete Maths</li>
                    <li> Extended real number system</li>
                    <li> Real Analysis</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b></p>
                <ul>
                    <li> First-Order Partial Differential Equations</li>
                    <li> Monotone and Bounded Sequences</li>
                    <li> Algebra – II</li>
                    <li> Topology – I</li>
                    <li> Functional Analysis</li>
                    <li> Complex Analysis</li>
                    <li> Mathematical Modelling and Numerical Analysis – I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b></p>
                <ul>
                    <li> Calculus on Euclidean Space</li>
                    <li> Abstract Group Theory</li>
                    <li> Partial Sums, Root and Ratio Tests</li>
                    <li> Two-dimensional Flows of Inviscid Fluids</li>
                    <li> Numerical Analysis – I</li>
                    <li> Elective -I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b></p>
                <ul>
                    <li> Measure And Integration</li>
                    <li> Mathematical Methods</li>
                    <li> Differential Geometry</li>
                    <li> Lebesgue Integral, Convergence Theorems</li>
                    <li> Elective – II</li>
                    <li> Elective – III</li>
                </ul>
            </div>



        </div>

    </div>
</section>
